import { KakaoPixel, KakaoPixelEvent, KakaoPixelEventType } from './types';

const getKakaoPixel = () => (window as unknown as { kakaoPixel: KakaoPixel }).kakaoPixel;

const eventMap: Record<KakaoPixelEventType, (trackId: string) => void> = {
  [KakaoPixelEvent.SIGN_UP]: (trackId) => {
    getKakaoPixel()(trackId).pageView();
    getKakaoPixel()(trackId).completeRegistration();
  },
};
const TRACK_ID = '5174958686083042808';

export function sendKakaoPixel(eventType: KakaoPixelEventType) {
  if (typeof getKakaoPixel() === 'function') {
    eventMap[eventType](TRACK_ID);
  }
}
